import { createSelector } from 'reselect';

const notificationSelector = (state: any) => state.notification;

export const loadingSelector = createSelector(notificationSelector, (notification) => notification.loading);

export const searchNotificationSelector = createSelector(
  notificationSelector,
  (notification) => notification.filterSearchData
);

export const searchNotificationTotalSelector = createSelector(
  notificationSelector,
  (notification) => notification.filterSearchTotal
);

export const isMdkNotificationSelector = createSelector(
  notificationSelector,
  (notification) => notification.isMdkNotification
);

export const detailNotificationSelector = createSelector(
  notificationSelector,
  (notification) => notification.detailNotification
);

export const showSearchModalSelector = createSelector(
  notificationSelector,
  (notification) => notification.showSearchModal
);

export const successSelector = createSelector(notificationSelector, (notification) => notification.success);

export const messageSelector = createSelector(notificationSelector, (notification) => notification.message);

export const checkedNotificationsSelector = createSelector(
  notificationSelector,
  (notification) => notification.checkedNotifications
);

export const showSortModalSelector = createSelector(
  notificationSelector,
  (notification) => notification?.showSortModal
);

export const sortSelectionSelector = createSelector(notificationSelector, (notification) => notification?.sortSelected);

export const sortDirectionSelector = createSelector(
  notificationSelector,
  (notification) => notification?.sortDirection
);
